// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../types/schema';

import { FormsAnswerReview_TreeFragment } from './AnswerTree.generated';
import { gql } from '@apollo/client';
import { FormsAnswerReview_TreeFragmentDoc } from './AnswerTree.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type FormsAnswerReview_EvidenceFragment = { __typename?: 'AnswerEvidence', id: string, position: number, target?: { __typename?: 'FormAnswerTarget', schemaNodeID: string, arrayItemID?: string | null } | null, document: { __typename?: 'Document', id: string, name: string }, fileParagraphs?: Array<{ __typename?: 'FileParagraph', id: string, content: string, ocrStructure?: { __typename?: 'OCRParagraphStructure', version: number, inferredProvision?: { __typename?: 'OCRInferredProvision', parserVersion: number, status: Types.OcrProvisionStatus, path: Array<{ __typename?: 'OCRProvisionLabel', label: string, paragraphIndex: number, kind?: Types.OcrProvisionKind | null }> } | null } | null, boundingRegions: Array<{ __typename?: 'BoundingRegion', PageNumber: number, Polygon: Array<{ __typename?: 'Coordinate', x: number, y: number }> }> }> | null };

export type FormsAnswerReview_RevisionFragment = { __typename?: 'AnswerRevision', id: string, value?: any | null, origin: Types.AnswerRevisionOrigin, confidence?: Types.AnswerRevisionConfidence | null, reasoning?: string | null, answerTree?: (
    { __typename?: 'FormAnswerTree' }
    & FormsAnswerReview_TreeFragment
  ) | null, evidence?: Array<(
    { __typename?: 'AnswerEvidence' }
    & FormsAnswerReview_EvidenceFragment
  )> | null };

export type FormsDiagnostics_FormSubmissionDiagnosticsFragment = { __typename?: 'FormSubmissionDiagnostics', submissionID: string, attempts: Array<{ __typename?: 'FormSubmissionDiagnosticAttempt', workflowTrackerID: string, status: Types.WorkflowTrackerStatus, startedAt: Time, endedAt?: Time | null, temporalID: string, temporalRunID: string }> };

export type FormsAnswerReview_AnswerFragment = { __typename?: 'Answer', id: string, householdID: string, fieldID: string, lockVersion: number, currentRevision?: (
    { __typename?: 'AnswerRevision' }
    & FormsAnswerReview_RevisionFragment
  ) | null, latestAIRevision?: (
    { __typename?: 'AnswerRevision' }
    & FormsAnswerReview_RevisionFragment
  ) | null };

export type FormsAnswerReview_SubmissionFragment = { __typename?: 'Submission', id: string, name?: string | null, householdID: string, status: Types.SubmissionStatus, createdAt: Time, updatedAt: Time, completedAt?: Time | null, formVersion: { __typename?: 'FormVersion', id: string, schemaVersion: number, config: any, form: { __typename?: 'Form', id: string, name: string } }, answers?: Array<(
    { __typename?: 'Answer' }
    & FormsAnswerReview_AnswerFragment
  )> | null, sourceDocuments: { __typename?: 'DocumentConnection', edges?: Array<{ __typename?: 'DocumentEdge', node?: { __typename?: 'Document', id: string, name: string } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: any | null } } };

export type FormSubmissionsQueryVariables = Types.Exact<{
  householdID: Types.Scalars['ID']['input'];
  after?: Types.InputMaybe<Types.Scalars['Cursor']['input']>;
  includeDiagnostics?: Types.Scalars['Boolean']['input'];
}>;


export type FormSubmissionsQuery = { __typename?: 'Query', formSubmissionDiagnostics?: Array<(
    { __typename?: 'FormSubmissionDiagnostics' }
    & FormsDiagnostics_FormSubmissionDiagnosticsFragment
  )>, submissions: { __typename?: 'SubmissionConnection', edges?: Array<{ __typename?: 'SubmissionEdge', node?: { __typename?: 'Submission', id: string, name?: string | null, status: Types.SubmissionStatus, updatedAt: Time, completedAt?: Time | null, formVersion: { __typename?: 'FormVersion', id: string, schemaVersion: number, config: any, form: { __typename?: 'Form', id: string, name: string } }, sourceDocuments: { __typename?: 'DocumentConnection', edges?: Array<{ __typename?: 'DocumentEdge', node?: { __typename?: 'Document', id: string, name: string } | null } | null> | null } } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: any | null } } };

export type FormSubmissionQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  sourceAfter?: Types.InputMaybe<Types.Scalars['Cursor']['input']>;
}>;


export type FormSubmissionQuery = { __typename?: 'Query', node?: { __typename: 'AISuggestion' } | { __typename: 'AISuggestionEvidence' } | { __typename: 'AccessAgeParameter' } | { __typename: 'AccessParameter' } | { __typename: 'Account' } | { __typename: 'ActiveEstateInsightsPage' } | { __typename: 'Activity' } | { __typename: 'Address' } | { __typename: 'Answer' } | { __typename: 'AnswerEvidence' } | { __typename: 'AnswerRevision' } | { __typename: 'Approval' } | { __typename: 'AssetClass' } | { __typename: 'AssetGroup' } | { __typename: 'AssetStatic' } | { __typename: 'AssetV2' } | { __typename: 'AssetValuationV2' } | { __typename: 'AssetValueV2' } | { __typename: 'AsyncJob' } | { __typename: 'BalanceSheetBundleConfiguration' } | { __typename: 'BalanceSheetCategory' } | { __typename: 'BalanceSheetViewConfiguration' } | { __typename: 'BeneficiariesBundleConfiguration' } | { __typename: 'BeneficiariesTemplateBundleConfiguration' } | { __typename: 'Beneficiary' } | { __typename: 'BeneficiaryAccessParameter' } | { __typename: 'BeneficiaryDesignationGroup' } | { __typename: 'BeneficiaryDistribution' } | { __typename: 'BeneficiaryDistributionParameter' } | { __typename: 'BeneficiaryPage' } | { __typename: 'BeneficiaryPowerOfAppointment' } | { __typename: 'CCorpBusinessEntity' } | { __typename: 'CLTProposal' } | { __typename: 'CLTTrust' } | { __typename: 'CRTProposal' } | { __typename: 'CRTTrust' } | { __typename: 'Capability' } | { __typename: 'Cashflow' } | { __typename: 'ClientOrganization' } | { __typename: 'ClientPresentationV2' } | { __typename: 'ClientProfile' } | { __typename: 'ClientProfileRelationship' } | { __typename: 'Collaborator' } | { __typename: 'ComparedWaterfall' } | { __typename: 'CompletedEstateInsightsPage' } | { __typename: 'ControllingParty' } | { __typename: 'Conversation' } | { __typename: 'CoverPageConfiguration' } | { __typename: 'CustodialPersonalAccount' } | { __typename: 'DSUEPortability' } | { __typename: 'DiagramArtifact' } | { __typename: 'DiagramArtifactPrompt' } | { __typename: 'DispositionScenario' } | { __typename: 'DispositiveProvision' } | { __typename: 'DispositiveProvisionTemplate' } | { __typename: 'DividerBundleConfiguration' } | { __typename: 'DividerTemplateBundleConfiguration' } | { __typename: 'Document' } | { __typename: 'DocumentQuestion' } | { __typename: 'DocumentQuestionAnswers' } | { __typename: 'DocumentSummary' } | { __typename: 'DocumentSummaryPage' } | { __typename: 'DocumentSummaryPrompt' } | { __typename: 'DocumentSummaryPromptTestRun' } | { __typename: 'DocumentSummaryTemplateBundleConfiguration' } | { __typename: 'DonorAdvisedFund' } | { __typename: 'Employee' } | { __typename: 'EntitiesOverviewBundleConfiguration' } | { __typename: 'EntitiesOverviewBundleConfigurationEntity' } | { __typename: 'Entity' } | { __typename: 'EntityDiagram' } | { __typename: 'EntityDocumentRelationship' } | { __typename: 'EntityGraphView' } | { __typename: 'EntityGraphViewBundleConfiguration' } | { __typename: 'EntityNotes' } | { __typename: 'EntityProposal' } | { __typename: 'EntitySummaryBundleConfiguration' } | { __typename: 'EntitySummaryTemplateBundleConfiguration' } | { __typename: 'EntityTask' } | { __typename: 'EntityTaxInfo' } | { __typename: 'EstateInsight' } | { __typename: 'EstateInsightReference' } | { __typename: 'EstateInsightsBundleConfiguration' } | { __typename: 'EstateTaxScenario' } | { __typename: 'EstateWaterfall' } | { __typename: 'EstateWaterfallHypotheticalStateChange' } | { __typename: 'EstateWaterfallHypotheticalTransfer' } | { __typename: 'EstateWaterfallMessageContext' } | { __typename: 'EstateWaterfallVisualizationConfig' } | { __typename: 'EstateWaterfallVisualizationFilter' } | { __typename: 'FamilyTreeBundleConfiguration' } | { __typename: 'FamilyTreeConfiguration' } | { __typename: 'FeatureFlag' } | { __typename: 'FeatureFlagQueryRule' } | { __typename: 'File' } | { __typename: 'FilePage' } | { __typename: 'FileParagraph' } | { __typename: 'Form' } | { __typename: 'FormVersion' } | { __typename: 'GPBusinessEntity' } | { __typename: 'GRATAnnuityV2' } | { __typename: 'GRATProposalScenario' } | { __typename: 'GRATTrust' } | { __typename: 'GiftingProposal' } | { __typename: 'GiftingProposalCashFlow' } | { __typename: 'GiftingProposalGift' } | { __typename: 'GiftingProposalGiftSender' } | { __typename: 'GiftingProposalPortfolio' } | { __typename: 'GiftingProposalScenario' } | { __typename: 'GraphVisualizationGroup' } | { __typename: 'GrowthProfile' } | { __typename: 'GrowthProfileOverride' } | { __typename: 'Household' } | { __typename: 'HypotheticalCLT' } | { __typename: 'HypotheticalCRT' } | { __typename: 'HypotheticalGRAT' } | { __typename: 'HypotheticalInsurance' } | { __typename: 'HypotheticalSaleLoan' } | { __typename: 'HypotheticalTransferAsset' } | { __typename: 'HypotheticalTransferFundingSource' } | { __typename: 'HypotheticalWaterfallDispositiveProvisionTemplate' } | { __typename: 'ILITCrummeyLetter' } | { __typename: 'ILITTrust' } | { __typename: 'Image' } | { __typename: 'IncomeTaxPaymentConfig' } | { __typename: 'IndividualPersonalAccount' } | { __typename: 'InferredField' } | { __typename: 'InferredFieldEvidence' } | { __typename: 'InsightsTemplateBundleConfiguration' } | { __typename: 'InsurancePersonalAccount' } | { __typename: 'InsurancePolicy' } | { __typename: 'InsurancePremiumPayment' } | { __typename: 'IntegrationAssetClass' } | { __typename: 'IntegrationCashflow' } | { __typename: 'IntegrationClient' } | { __typename: 'IntegrationConfiguration' } | { __typename: 'IntegrationEntity' } | { __typename: 'IntegrationInsurance' } | { __typename: 'IntegrationLiability' } | { __typename: 'IntegrationPerson' } | { __typename: 'IrrevocableTrust' } | { __typename: 'JointPersonalAccount' } | { __typename: 'KGNode' } | { __typename: 'KGRelationship' } | { __typename: 'KGRoot' } | { __typename: 'KGV2Document' } | { __typename: 'KGV2DocumentChange' } | { __typename: 'KGV2DocumentModification' } | { __typename: 'KGV2Graph' } | { __typename: 'KGV2Node' } | { __typename: 'KGV2NodeAlias' } | { __typename: 'KGV2NodeEvidence' } | { __typename: 'KGV2Statement' } | { __typename: 'KGV2StatementEvidence' } | { __typename: 'KGV2StatementSupersession' } | { __typename: 'KeyPerson' } | { __typename: 'KeyPersonRole' } | { __typename: 'LLCBusinessEntity' } | { __typename: 'LPBusinessEntity' } | { __typename: 'LiabilitiesBundleConfiguration' } | { __typename: 'Liability' } | { __typename: 'LiabilityPayment' } | { __typename: 'LifeInsuranceBundleConfiguration' } | { __typename: 'LifetimeExclusionEvent' } | { __typename: 'LoggedTransfer' } | { __typename: 'LuminaryOrganization' } | { __typename: 'LuminaryTenantJIT' } | { __typename: 'ManagedSFTPConnection' } | { __typename: 'Memo' } | { __typename: 'MemoPrompt' } | { __typename: 'Message' } | { __typename: 'MissingDocumentOverride' } | { __typename: 'MissingDocumentsPage' } | { __typename: 'ModelMapping' } | { __typename: 'NotificationApp' } | { __typename: 'NotificationPreference' } | { __typename: 'OpenaiSdkConfig' } | { __typename: 'OrganizationApplicationConfiguration' } | { __typename: 'OrganizationDisclaimerConfiguration' } | { __typename: 'OwnershipStake' } | { __typename: 'PlatformDocument' } | { __typename: 'PlatformFile' } | { __typename: 'PlatformFilePage' } | { __typename: 'PlatformFileParagraph' } | { __typename: 'PresentationApprovalRequest' } | { __typename: 'PresentationAssetDistributionBundleConfiguration' } | { __typename: 'PresentationAssetDistributionItemConfiguration' } | { __typename: 'PresentationAssetDistributionItemDetail' } | { __typename: 'PresentationBundle' } | { __typename: 'PresentationBundleCoverPage' } | { __typename: 'PresentationBusinessOverviewBundleConfiguration' } | { __typename: 'PresentationBusinessOverviewBusinessConfiguration' } | { __typename: 'PresentationBusinessOverviewItem' } | { __typename: 'PresentationCoverPage' } | { __typename: 'PresentationCoverSlideConfig' } | { __typename: 'PresentationCustomPage' } | { __typename: 'PresentationCustomPageBundleConfiguration' } | { __typename: 'PresentationDiagramPage' } | { __typename: 'PresentationDocumentsReviewedBundleConfiguration' } | { __typename: 'PresentationDocumentsReviewedDocument' } | { __typename: 'PresentationFamilyOverviewBundleConfiguration' } | { __typename: 'PresentationFamilyOverviewMemberConfiguration' } | { __typename: 'PresentationHealthcareDirectiveBundleConfiguration' } | { __typename: 'PresentationHealthcareDirectiveClientConfiguration' } | { __typename: 'PresentationHealthcareDirectiveItem' } | { __typename: 'PresentationItemCitation' } | { __typename: 'PresentationPage' } | { __typename: 'PresentationPlanningOpportunitiesBundleConfiguration' } | { __typename: 'PresentationPlanningOpportunitiesItem' } | { __typename: 'PresentationPowerOfAttorneyBundleConfiguration' } | { __typename: 'PresentationPowerOfAttorneyClientConfiguration' } | { __typename: 'PresentationPowerOfAttorneyItem' } | { __typename: 'PresentationTemplate' } | { __typename: 'PresentationTemplateBundle' } | { __typename: 'PresentationTemplateCoverPage' } | { __typename: 'PresentationTemplateCustomPage' } | { __typename: 'PresentationTemplateDiagramPage' } | { __typename: 'PresentationTemplatePage' } | { __typename: 'PresentationTrustOverviewBundleConfiguration' } | { __typename: 'PresentationTrustOverviewItem' } | { __typename: 'PresentationTrustOverviewTrustConfiguration' } | { __typename: 'PresentationWillBundleConfiguration' } | { __typename: 'PresentationWillClientConfiguration' } | { __typename: 'PresentationWillItem' } | { __typename: 'Principal' } | { __typename: 'PrivateFoundation' } | { __typename: 'ProfessionalTeamRole' } | { __typename: 'Proposal' } | { __typename: 'ProposalScenario' } | { __typename: 'QPRTTrust' } | { __typename: 'QualifiedTuitionPersonalAccount' } | { __typename: 'ReleaseGroup' } | { __typename: 'ReminderEmailNotificationRecord' } | { __typename: 'RetirementPersonalAccount' } | { __typename: 'RevocableTrust' } | { __typename: 'Role' } | { __typename: 'SCorpBusinessEntity' } | { __typename: 'SLATTrust' } | { __typename: 'SSOConnection' } | { __typename: 'SalesforceExportAttempt' } | { __typename: 'ScheduledDistribution' } | { __typename: 'SoleProprietorshipBusinessEntity' } | { __typename: 'SubBrand' } | { __typename: 'SubBrandDisclaimerConfiguration' } | (
    { __typename: 'Submission' }
    & FormsAnswerReview_SubmissionFragment
  ) | { __typename: 'TaxDragConfig' } | { __typename: 'TaxDragOverride' } | { __typename: 'Team' } | { __typename: 'Tenant' } | { __typename: 'TenantApplicationConfiguration' } | { __typename: 'TenantBranding' } | { __typename: 'TenantDisclaimerConfiguration' } | { __typename: 'TenantDocument' } | { __typename: 'TenantReminderEmailsConfiguration' } | { __typename: 'TenantSSOConnection' } | { __typename: 'TenantSecurityConfiguration' } | { __typename: 'TenantSlideConfig' } | { __typename: 'TestCMKEncryption' } | { __typename: 'TestamentaryEntity' } | { __typename: 'TrustAdvisor' } | { __typename: 'TrustAdvisorRole' } | { __typename: 'Trustee' } | { __typename: 'TrusteeDuty' } | { __typename: 'User' } | { __typename: 'UserFeedback' } | { __typename: 'UserNotificationConfiguration' } | { __typename: 'WaterfallBundleConfiguration' } | { __typename: 'WaterfallBundleCoverPage' } | { __typename: 'WaterfallComparisonBundleConfiguration' } | { __typename: 'WaterfallComparisonTemplateBundleConfiguration' } | { __typename: 'WaterfallTemplateBundleConfiguration' } | { __typename: 'WorkOSOrganization' } | { __typename: 'WorkOSOrganizationDomain' } | { __typename: 'WorkflowTracker' } | null };

export type FormSubmissionStatusQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type FormSubmissionStatusQuery = { __typename?: 'Query', node?: { __typename: 'AISuggestion' } | { __typename: 'AISuggestionEvidence' } | { __typename: 'AccessAgeParameter' } | { __typename: 'AccessParameter' } | { __typename: 'Account' } | { __typename: 'ActiveEstateInsightsPage' } | { __typename: 'Activity' } | { __typename: 'Address' } | { __typename: 'Answer' } | { __typename: 'AnswerEvidence' } | { __typename: 'AnswerRevision' } | { __typename: 'Approval' } | { __typename: 'AssetClass' } | { __typename: 'AssetGroup' } | { __typename: 'AssetStatic' } | { __typename: 'AssetV2' } | { __typename: 'AssetValuationV2' } | { __typename: 'AssetValueV2' } | { __typename: 'AsyncJob' } | { __typename: 'BalanceSheetBundleConfiguration' } | { __typename: 'BalanceSheetCategory' } | { __typename: 'BalanceSheetViewConfiguration' } | { __typename: 'BeneficiariesBundleConfiguration' } | { __typename: 'BeneficiariesTemplateBundleConfiguration' } | { __typename: 'Beneficiary' } | { __typename: 'BeneficiaryAccessParameter' } | { __typename: 'BeneficiaryDesignationGroup' } | { __typename: 'BeneficiaryDistribution' } | { __typename: 'BeneficiaryDistributionParameter' } | { __typename: 'BeneficiaryPage' } | { __typename: 'BeneficiaryPowerOfAppointment' } | { __typename: 'CCorpBusinessEntity' } | { __typename: 'CLTProposal' } | { __typename: 'CLTTrust' } | { __typename: 'CRTProposal' } | { __typename: 'CRTTrust' } | { __typename: 'Capability' } | { __typename: 'Cashflow' } | { __typename: 'ClientOrganization' } | { __typename: 'ClientPresentationV2' } | { __typename: 'ClientProfile' } | { __typename: 'ClientProfileRelationship' } | { __typename: 'Collaborator' } | { __typename: 'ComparedWaterfall' } | { __typename: 'CompletedEstateInsightsPage' } | { __typename: 'ControllingParty' } | { __typename: 'Conversation' } | { __typename: 'CoverPageConfiguration' } | { __typename: 'CustodialPersonalAccount' } | { __typename: 'DSUEPortability' } | { __typename: 'DiagramArtifact' } | { __typename: 'DiagramArtifactPrompt' } | { __typename: 'DispositionScenario' } | { __typename: 'DispositiveProvision' } | { __typename: 'DispositiveProvisionTemplate' } | { __typename: 'DividerBundleConfiguration' } | { __typename: 'DividerTemplateBundleConfiguration' } | { __typename: 'Document' } | { __typename: 'DocumentQuestion' } | { __typename: 'DocumentQuestionAnswers' } | { __typename: 'DocumentSummary' } | { __typename: 'DocumentSummaryPage' } | { __typename: 'DocumentSummaryPrompt' } | { __typename: 'DocumentSummaryPromptTestRun' } | { __typename: 'DocumentSummaryTemplateBundleConfiguration' } | { __typename: 'DonorAdvisedFund' } | { __typename: 'Employee' } | { __typename: 'EntitiesOverviewBundleConfiguration' } | { __typename: 'EntitiesOverviewBundleConfigurationEntity' } | { __typename: 'Entity' } | { __typename: 'EntityDiagram' } | { __typename: 'EntityDocumentRelationship' } | { __typename: 'EntityGraphView' } | { __typename: 'EntityGraphViewBundleConfiguration' } | { __typename: 'EntityNotes' } | { __typename: 'EntityProposal' } | { __typename: 'EntitySummaryBundleConfiguration' } | { __typename: 'EntitySummaryTemplateBundleConfiguration' } | { __typename: 'EntityTask' } | { __typename: 'EntityTaxInfo' } | { __typename: 'EstateInsight' } | { __typename: 'EstateInsightReference' } | { __typename: 'EstateInsightsBundleConfiguration' } | { __typename: 'EstateTaxScenario' } | { __typename: 'EstateWaterfall' } | { __typename: 'EstateWaterfallHypotheticalStateChange' } | { __typename: 'EstateWaterfallHypotheticalTransfer' } | { __typename: 'EstateWaterfallMessageContext' } | { __typename: 'EstateWaterfallVisualizationConfig' } | { __typename: 'EstateWaterfallVisualizationFilter' } | { __typename: 'FamilyTreeBundleConfiguration' } | { __typename: 'FamilyTreeConfiguration' } | { __typename: 'FeatureFlag' } | { __typename: 'FeatureFlagQueryRule' } | { __typename: 'File' } | { __typename: 'FilePage' } | { __typename: 'FileParagraph' } | { __typename: 'Form' } | { __typename: 'FormVersion' } | { __typename: 'GPBusinessEntity' } | { __typename: 'GRATAnnuityV2' } | { __typename: 'GRATProposalScenario' } | { __typename: 'GRATTrust' } | { __typename: 'GiftingProposal' } | { __typename: 'GiftingProposalCashFlow' } | { __typename: 'GiftingProposalGift' } | { __typename: 'GiftingProposalGiftSender' } | { __typename: 'GiftingProposalPortfolio' } | { __typename: 'GiftingProposalScenario' } | { __typename: 'GraphVisualizationGroup' } | { __typename: 'GrowthProfile' } | { __typename: 'GrowthProfileOverride' } | { __typename: 'Household' } | { __typename: 'HypotheticalCLT' } | { __typename: 'HypotheticalCRT' } | { __typename: 'HypotheticalGRAT' } | { __typename: 'HypotheticalInsurance' } | { __typename: 'HypotheticalSaleLoan' } | { __typename: 'HypotheticalTransferAsset' } | { __typename: 'HypotheticalTransferFundingSource' } | { __typename: 'HypotheticalWaterfallDispositiveProvisionTemplate' } | { __typename: 'ILITCrummeyLetter' } | { __typename: 'ILITTrust' } | { __typename: 'Image' } | { __typename: 'IncomeTaxPaymentConfig' } | { __typename: 'IndividualPersonalAccount' } | { __typename: 'InferredField' } | { __typename: 'InferredFieldEvidence' } | { __typename: 'InsightsTemplateBundleConfiguration' } | { __typename: 'InsurancePersonalAccount' } | { __typename: 'InsurancePolicy' } | { __typename: 'InsurancePremiumPayment' } | { __typename: 'IntegrationAssetClass' } | { __typename: 'IntegrationCashflow' } | { __typename: 'IntegrationClient' } | { __typename: 'IntegrationConfiguration' } | { __typename: 'IntegrationEntity' } | { __typename: 'IntegrationInsurance' } | { __typename: 'IntegrationLiability' } | { __typename: 'IntegrationPerson' } | { __typename: 'IrrevocableTrust' } | { __typename: 'JointPersonalAccount' } | { __typename: 'KGNode' } | { __typename: 'KGRelationship' } | { __typename: 'KGRoot' } | { __typename: 'KGV2Document' } | { __typename: 'KGV2DocumentChange' } | { __typename: 'KGV2DocumentModification' } | { __typename: 'KGV2Graph' } | { __typename: 'KGV2Node' } | { __typename: 'KGV2NodeAlias' } | { __typename: 'KGV2NodeEvidence' } | { __typename: 'KGV2Statement' } | { __typename: 'KGV2StatementEvidence' } | { __typename: 'KGV2StatementSupersession' } | { __typename: 'KeyPerson' } | { __typename: 'KeyPersonRole' } | { __typename: 'LLCBusinessEntity' } | { __typename: 'LPBusinessEntity' } | { __typename: 'LiabilitiesBundleConfiguration' } | { __typename: 'Liability' } | { __typename: 'LiabilityPayment' } | { __typename: 'LifeInsuranceBundleConfiguration' } | { __typename: 'LifetimeExclusionEvent' } | { __typename: 'LoggedTransfer' } | { __typename: 'LuminaryOrganization' } | { __typename: 'LuminaryTenantJIT' } | { __typename: 'ManagedSFTPConnection' } | { __typename: 'Memo' } | { __typename: 'MemoPrompt' } | { __typename: 'Message' } | { __typename: 'MissingDocumentOverride' } | { __typename: 'MissingDocumentsPage' } | { __typename: 'ModelMapping' } | { __typename: 'NotificationApp' } | { __typename: 'NotificationPreference' } | { __typename: 'OpenaiSdkConfig' } | { __typename: 'OrganizationApplicationConfiguration' } | { __typename: 'OrganizationDisclaimerConfiguration' } | { __typename: 'OwnershipStake' } | { __typename: 'PlatformDocument' } | { __typename: 'PlatformFile' } | { __typename: 'PlatformFilePage' } | { __typename: 'PlatformFileParagraph' } | { __typename: 'PresentationApprovalRequest' } | { __typename: 'PresentationAssetDistributionBundleConfiguration' } | { __typename: 'PresentationAssetDistributionItemConfiguration' } | { __typename: 'PresentationAssetDistributionItemDetail' } | { __typename: 'PresentationBundle' } | { __typename: 'PresentationBundleCoverPage' } | { __typename: 'PresentationBusinessOverviewBundleConfiguration' } | { __typename: 'PresentationBusinessOverviewBusinessConfiguration' } | { __typename: 'PresentationBusinessOverviewItem' } | { __typename: 'PresentationCoverPage' } | { __typename: 'PresentationCoverSlideConfig' } | { __typename: 'PresentationCustomPage' } | { __typename: 'PresentationCustomPageBundleConfiguration' } | { __typename: 'PresentationDiagramPage' } | { __typename: 'PresentationDocumentsReviewedBundleConfiguration' } | { __typename: 'PresentationDocumentsReviewedDocument' } | { __typename: 'PresentationFamilyOverviewBundleConfiguration' } | { __typename: 'PresentationFamilyOverviewMemberConfiguration' } | { __typename: 'PresentationHealthcareDirectiveBundleConfiguration' } | { __typename: 'PresentationHealthcareDirectiveClientConfiguration' } | { __typename: 'PresentationHealthcareDirectiveItem' } | { __typename: 'PresentationItemCitation' } | { __typename: 'PresentationPage' } | { __typename: 'PresentationPlanningOpportunitiesBundleConfiguration' } | { __typename: 'PresentationPlanningOpportunitiesItem' } | { __typename: 'PresentationPowerOfAttorneyBundleConfiguration' } | { __typename: 'PresentationPowerOfAttorneyClientConfiguration' } | { __typename: 'PresentationPowerOfAttorneyItem' } | { __typename: 'PresentationTemplate' } | { __typename: 'PresentationTemplateBundle' } | { __typename: 'PresentationTemplateCoverPage' } | { __typename: 'PresentationTemplateCustomPage' } | { __typename: 'PresentationTemplateDiagramPage' } | { __typename: 'PresentationTemplatePage' } | { __typename: 'PresentationTrustOverviewBundleConfiguration' } | { __typename: 'PresentationTrustOverviewItem' } | { __typename: 'PresentationTrustOverviewTrustConfiguration' } | { __typename: 'PresentationWillBundleConfiguration' } | { __typename: 'PresentationWillClientConfiguration' } | { __typename: 'PresentationWillItem' } | { __typename: 'Principal' } | { __typename: 'PrivateFoundation' } | { __typename: 'ProfessionalTeamRole' } | { __typename: 'Proposal' } | { __typename: 'ProposalScenario' } | { __typename: 'QPRTTrust' } | { __typename: 'QualifiedTuitionPersonalAccount' } | { __typename: 'ReleaseGroup' } | { __typename: 'ReminderEmailNotificationRecord' } | { __typename: 'RetirementPersonalAccount' } | { __typename: 'RevocableTrust' } | { __typename: 'Role' } | { __typename: 'SCorpBusinessEntity' } | { __typename: 'SLATTrust' } | { __typename: 'SSOConnection' } | { __typename: 'SalesforceExportAttempt' } | { __typename: 'ScheduledDistribution' } | { __typename: 'SoleProprietorshipBusinessEntity' } | { __typename: 'SubBrand' } | { __typename: 'SubBrandDisclaimerConfiguration' } | { __typename: 'Submission', id: string, status: Types.SubmissionStatus } | { __typename: 'TaxDragConfig' } | { __typename: 'TaxDragOverride' } | { __typename: 'Team' } | { __typename: 'Tenant' } | { __typename: 'TenantApplicationConfiguration' } | { __typename: 'TenantBranding' } | { __typename: 'TenantDisclaimerConfiguration' } | { __typename: 'TenantDocument' } | { __typename: 'TenantReminderEmailsConfiguration' } | { __typename: 'TenantSSOConnection' } | { __typename: 'TenantSecurityConfiguration' } | { __typename: 'TenantSlideConfig' } | { __typename: 'TestCMKEncryption' } | { __typename: 'TestamentaryEntity' } | { __typename: 'TrustAdvisor' } | { __typename: 'TrustAdvisorRole' } | { __typename: 'Trustee' } | { __typename: 'TrusteeDuty' } | { __typename: 'User' } | { __typename: 'UserFeedback' } | { __typename: 'UserNotificationConfiguration' } | { __typename: 'WaterfallBundleConfiguration' } | { __typename: 'WaterfallBundleCoverPage' } | { __typename: 'WaterfallComparisonBundleConfiguration' } | { __typename: 'WaterfallComparisonTemplateBundleConfiguration' } | { __typename: 'WaterfallTemplateBundleConfiguration' } | { __typename: 'WorkOSOrganization' } | { __typename: 'WorkOSOrganizationDomain' } | { __typename: 'WorkflowTracker' } | null };

export type ReviewPublishedFormsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ReviewPublishedFormsQuery = { __typename?: 'Query', forms: { __typename?: 'FormConnection', edges?: Array<{ __typename?: 'FormEdge', node?: { __typename?: 'Form', id: string, name: string, currentPublishedVersion?: { __typename?: 'FormVersion', id: string } | null } | null } | null> | null } };

export type CreateFormSubmissionMutationVariables = Types.Exact<{
  input: Types.CreateFormSubmissionInput;
}>;


export type CreateFormSubmissionMutation = { __typename?: 'Mutation', createFormSubmission: { __typename?: 'Submission', id: string, status: Types.SubmissionStatus } };

export type ArchiveFormSubmissionMutationVariables = Types.Exact<{
  submissionID: Types.Scalars['ID']['input'];
}>;


export type ArchiveFormSubmissionMutation = { __typename?: 'Mutation', archiveFormSubmission: { __typename?: 'Submission', id: string } };

export type UpdateFormSubmissionNameMutationVariables = Types.Exact<{
  input: Types.UpdateFormSubmissionNameInput;
}>;


export type UpdateFormSubmissionNameMutation = { __typename?: 'Mutation', updateFormSubmissionName: { __typename?: 'Submission', id: string, name?: string | null, updatedAt: Time } };

export type StartFormSubmissionExtractionMutationVariables = Types.Exact<{
  input: Types.StartFormSubmissionExtractionInput;
}>;


export type StartFormSubmissionExtractionMutation = { __typename?: 'Mutation', startFormSubmissionExtraction: { __typename?: 'Submission', id: string, status: Types.SubmissionStatus } };

export type SetFormSubmissionAnswerMutationVariables = Types.Exact<{
  input: Types.SetFormSubmissionAnswerInput;
}>;


export type SetFormSubmissionAnswerMutation = { __typename?: 'Mutation', setFormSubmissionAnswer: { __typename?: 'FormSubmissionAnswerMutationPayload', answer?: (
      { __typename?: 'Answer' }
      & FormsAnswerReview_AnswerFragment
    ) | null, conflict?: { __typename?: 'FormSubmissionAnswerConflict', expectedLockVersion: number, actualLockVersion: number, currentAnswer?: (
        { __typename?: 'Answer' }
        & FormsAnswerReview_AnswerFragment
      ) | null } | null } };

export type ClearFormSubmissionAnswerMutationVariables = Types.Exact<{
  input: Types.ClearFormSubmissionAnswerInput;
}>;


export type ClearFormSubmissionAnswerMutation = { __typename?: 'Mutation', clearFormSubmissionAnswer: { __typename?: 'FormSubmissionAnswerMutationPayload', answer?: (
      { __typename?: 'Answer' }
      & FormsAnswerReview_AnswerFragment
    ) | null, conflict?: { __typename?: 'FormSubmissionAnswerConflict', expectedLockVersion: number, actualLockVersion: number, currentAnswer?: (
        { __typename?: 'Answer' }
        & FormsAnswerReview_AnswerFragment
      ) | null } | null } };

export type EnqueueFormSubmissionWordExportMutationVariables = Types.Exact<{
  input: Types.ExportFormSubmissionWordInput;
}>;


export type EnqueueFormSubmissionWordExportMutation = { __typename?: 'Mutation', enqueueFormSubmissionWordExport: { __typename?: 'WorkflowTracker', id: string, status: Types.WorkflowTrackerStatus } };

export type SetFormSubmissionAnswerReferencesMutationVariables = Types.Exact<{
  input: Types.SetFormSubmissionAnswerReferencesInput;
}>;


export type SetFormSubmissionAnswerReferencesMutation = { __typename?: 'Mutation', setFormSubmissionAnswerReferences: { __typename?: 'FormSubmissionAnswerMutationPayload', answer?: (
      { __typename?: 'Answer' }
      & FormsAnswerReview_AnswerFragment
    ) | null, conflict?: { __typename?: 'FormSubmissionAnswerConflict', expectedLockVersion: number, actualLockVersion: number, currentAnswer?: (
        { __typename?: 'Answer' }
        & FormsAnswerReview_AnswerFragment
      ) | null } | null } };

export const Operations = {
  Query: {
    FormSubmissions: 'FormSubmissions' as const,
    FormSubmission: 'FormSubmission' as const,
    FormSubmissionStatus: 'FormSubmissionStatus' as const,
    ReviewPublishedForms: 'ReviewPublishedForms' as const
  },
  Mutation: {
    CreateFormSubmission: 'CreateFormSubmission' as const,
    ArchiveFormSubmission: 'ArchiveFormSubmission' as const,
    UpdateFormSubmissionName: 'UpdateFormSubmissionName' as const,
    StartFormSubmissionExtraction: 'StartFormSubmissionExtraction' as const,
    SetFormSubmissionAnswer: 'SetFormSubmissionAnswer' as const,
    ClearFormSubmissionAnswer: 'ClearFormSubmissionAnswer' as const,
    EnqueueFormSubmissionWordExport: 'EnqueueFormSubmissionWordExport' as const,
    SetFormSubmissionAnswerReferences: 'SetFormSubmissionAnswerReferences' as const
  },
  Fragment: {
    FormsAnswerReview_Evidence: 'FormsAnswerReview_Evidence' as const,
    FormsAnswerReview_Revision: 'FormsAnswerReview_Revision' as const,
    FormsDiagnostics_FormSubmissionDiagnostics: 'FormsDiagnostics_FormSubmissionDiagnostics' as const,
    FormsAnswerReview_Answer: 'FormsAnswerReview_Answer' as const,
    FormsAnswerReview_Submission: 'FormsAnswerReview_Submission' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const FormsDiagnostics_FormSubmissionDiagnosticsFragmentDoc = gql`
    fragment FormsDiagnostics_FormSubmissionDiagnostics on FormSubmissionDiagnostics {
  submissionID
  attempts {
    workflowTrackerID
    status
    startedAt
    endedAt
    temporalID
    temporalRunID
  }
}
    `;
export const FormsAnswerReview_EvidenceFragmentDoc = gql`
    fragment FormsAnswerReview_Evidence on AnswerEvidence {
  id
  position
  target {
    schemaNodeID
    arrayItemID
  }
  document {
    id
    name
  }
  fileParagraphs {
    id
    content
    ocrStructure {
      version
      inferredProvision {
        parserVersion
        status
        path {
          label
          paragraphIndex
          kind
        }
      }
    }
    boundingRegions {
      PageNumber
      Polygon {
        x
        y
      }
    }
  }
}
    `;
export const FormsAnswerReview_RevisionFragmentDoc = gql`
    fragment FormsAnswerReview_Revision on AnswerRevision {
  id
  value
  answerTree {
    ...FormsAnswerReview_Tree
  }
  origin
  confidence
  reasoning
  evidence {
    ...FormsAnswerReview_Evidence
  }
}
    ${FormsAnswerReview_TreeFragmentDoc}
${FormsAnswerReview_EvidenceFragmentDoc}`;
export const FormsAnswerReview_AnswerFragmentDoc = gql`
    fragment FormsAnswerReview_Answer on Answer {
  id
  householdID
  fieldID
  lockVersion
  currentRevision {
    ...FormsAnswerReview_Revision
  }
  latestAIRevision {
    ...FormsAnswerReview_Revision
  }
}
    ${FormsAnswerReview_RevisionFragmentDoc}`;
export const FormsAnswerReview_SubmissionFragmentDoc = gql`
    fragment FormsAnswerReview_Submission on Submission {
  id
  name
  householdID
  status
  createdAt
  updatedAt
  completedAt
  formVersion {
    id
    schemaVersion
    config
    form {
      id
      name
    }
  }
  answers {
    ...FormsAnswerReview_Answer
  }
  sourceDocuments(first: 100, after: $sourceAfter) {
    edges {
      node {
        id
        name
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    ${FormsAnswerReview_AnswerFragmentDoc}`;
export const FormSubmissionsDocument = gql`
    query FormSubmissions($householdID: ID!, $after: Cursor, $includeDiagnostics: Boolean! = false) {
  formSubmissionDiagnostics(householdID: $householdID) @include(if: $includeDiagnostics) {
    ...FormsDiagnostics_FormSubmissionDiagnostics
  }
  submissions(
    where: {householdID: $householdID, archivedAtIsNil: true}
    first: 100
    after: $after
    orderBy: [{field: updated_at, direction: DESC}]
  ) {
    edges {
      node {
        id
        name
        formVersion {
          id
          schemaVersion
          config
          form {
            id
            name
          }
        }
        status
        updatedAt
        completedAt
        sourceDocuments(first: 100) {
          edges {
            node {
              id
              name
            }
          }
        }
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    ${FormsDiagnostics_FormSubmissionDiagnosticsFragmentDoc}`;

/**
 * __useFormSubmissionsQuery__
 *
 * To run a query within a React component, call `useFormSubmissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormSubmissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormSubmissionsQuery({
 *   variables: {
 *      householdID: // value for 'householdID'
 *      after: // value for 'after'
 *      includeDiagnostics: // value for 'includeDiagnostics'
 *   },
 * });
 */
export function useFormSubmissionsQuery(baseOptions: Apollo.QueryHookOptions<FormSubmissionsQuery, FormSubmissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FormSubmissionsQuery, FormSubmissionsQueryVariables>(FormSubmissionsDocument, withFetchPolicyContext(options));
      }
export function useFormSubmissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FormSubmissionsQuery, FormSubmissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FormSubmissionsQuery, FormSubmissionsQueryVariables>(FormSubmissionsDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useFormSubmissionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FormSubmissionsQuery, FormSubmissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FormSubmissionsQuery, FormSubmissionsQueryVariables>(FormSubmissionsDocument, withFetchPolicyContext(options));
        }
export type FormSubmissionsQueryHookResult = ReturnType<typeof useFormSubmissionsQuery>;
export type FormSubmissionsLazyQueryHookResult = ReturnType<typeof useFormSubmissionsLazyQuery>;
export type FormSubmissionsSuspenseQueryHookResult = ReturnType<typeof useFormSubmissionsSuspenseQuery>;
export type FormSubmissionsQueryResult = Apollo.QueryResult<FormSubmissionsQuery, FormSubmissionsQueryVariables>;
export const FormSubmissionDocument = gql`
    query FormSubmission($id: ID!, $sourceAfter: Cursor) {
  node(id: $id) {
    __typename
    ...FormsAnswerReview_Submission
  }
}
    ${FormsAnswerReview_SubmissionFragmentDoc}`;

/**
 * __useFormSubmissionQuery__
 *
 * To run a query within a React component, call `useFormSubmissionQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormSubmissionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormSubmissionQuery({
 *   variables: {
 *      id: // value for 'id'
 *      sourceAfter: // value for 'sourceAfter'
 *   },
 * });
 */
export function useFormSubmissionQuery(baseOptions: Apollo.QueryHookOptions<FormSubmissionQuery, FormSubmissionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FormSubmissionQuery, FormSubmissionQueryVariables>(FormSubmissionDocument, withFetchPolicyContext(options));
      }
export function useFormSubmissionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FormSubmissionQuery, FormSubmissionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FormSubmissionQuery, FormSubmissionQueryVariables>(FormSubmissionDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useFormSubmissionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FormSubmissionQuery, FormSubmissionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FormSubmissionQuery, FormSubmissionQueryVariables>(FormSubmissionDocument, withFetchPolicyContext(options));
        }
export type FormSubmissionQueryHookResult = ReturnType<typeof useFormSubmissionQuery>;
export type FormSubmissionLazyQueryHookResult = ReturnType<typeof useFormSubmissionLazyQuery>;
export type FormSubmissionSuspenseQueryHookResult = ReturnType<typeof useFormSubmissionSuspenseQuery>;
export type FormSubmissionQueryResult = Apollo.QueryResult<FormSubmissionQuery, FormSubmissionQueryVariables>;
export const FormSubmissionStatusDocument = gql`
    query FormSubmissionStatus($id: ID!) {
  node(id: $id) {
    __typename
    ... on Submission {
      id
      status
    }
  }
}
    `;

/**
 * __useFormSubmissionStatusQuery__
 *
 * To run a query within a React component, call `useFormSubmissionStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormSubmissionStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormSubmissionStatusQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFormSubmissionStatusQuery(baseOptions: Apollo.QueryHookOptions<FormSubmissionStatusQuery, FormSubmissionStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FormSubmissionStatusQuery, FormSubmissionStatusQueryVariables>(FormSubmissionStatusDocument, withFetchPolicyContext(options));
      }
export function useFormSubmissionStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FormSubmissionStatusQuery, FormSubmissionStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FormSubmissionStatusQuery, FormSubmissionStatusQueryVariables>(FormSubmissionStatusDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useFormSubmissionStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FormSubmissionStatusQuery, FormSubmissionStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FormSubmissionStatusQuery, FormSubmissionStatusQueryVariables>(FormSubmissionStatusDocument, withFetchPolicyContext(options));
        }
export type FormSubmissionStatusQueryHookResult = ReturnType<typeof useFormSubmissionStatusQuery>;
export type FormSubmissionStatusLazyQueryHookResult = ReturnType<typeof useFormSubmissionStatusLazyQuery>;
export type FormSubmissionStatusSuspenseQueryHookResult = ReturnType<typeof useFormSubmissionStatusSuspenseQuery>;
export type FormSubmissionStatusQueryResult = Apollo.QueryResult<FormSubmissionStatusQuery, FormSubmissionStatusQueryVariables>;
export const ReviewPublishedFormsDocument = gql`
    query ReviewPublishedForms {
  forms(
    first: 100
    orderBy: [{field: updated_at, direction: DESC}]
    where: {archivedAtIsNil: true, hasCurrentPublishedVersion: true}
  ) {
    edges {
      node {
        id
        name
        currentPublishedVersion {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useReviewPublishedFormsQuery__
 *
 * To run a query within a React component, call `useReviewPublishedFormsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReviewPublishedFormsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReviewPublishedFormsQuery({
 *   variables: {
 *   },
 * });
 */
export function useReviewPublishedFormsQuery(baseOptions?: Apollo.QueryHookOptions<ReviewPublishedFormsQuery, ReviewPublishedFormsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReviewPublishedFormsQuery, ReviewPublishedFormsQueryVariables>(ReviewPublishedFormsDocument, withFetchPolicyContext(options));
      }
export function useReviewPublishedFormsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReviewPublishedFormsQuery, ReviewPublishedFormsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReviewPublishedFormsQuery, ReviewPublishedFormsQueryVariables>(ReviewPublishedFormsDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useReviewPublishedFormsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ReviewPublishedFormsQuery, ReviewPublishedFormsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReviewPublishedFormsQuery, ReviewPublishedFormsQueryVariables>(ReviewPublishedFormsDocument, withFetchPolicyContext(options));
        }
export type ReviewPublishedFormsQueryHookResult = ReturnType<typeof useReviewPublishedFormsQuery>;
export type ReviewPublishedFormsLazyQueryHookResult = ReturnType<typeof useReviewPublishedFormsLazyQuery>;
export type ReviewPublishedFormsSuspenseQueryHookResult = ReturnType<typeof useReviewPublishedFormsSuspenseQuery>;
export type ReviewPublishedFormsQueryResult = Apollo.QueryResult<ReviewPublishedFormsQuery, ReviewPublishedFormsQueryVariables>;
export const CreateFormSubmissionDocument = gql`
    mutation CreateFormSubmission($input: CreateFormSubmissionInput!) {
  createFormSubmission(input: $input) {
    id
    status
  }
}
    `;
export type CreateFormSubmissionMutationFn = Apollo.MutationFunction<CreateFormSubmissionMutation, CreateFormSubmissionMutationVariables>;

/**
 * __useCreateFormSubmissionMutation__
 *
 * To run a mutation, you first call `useCreateFormSubmissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFormSubmissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFormSubmissionMutation, { data, loading, error }] = useCreateFormSubmissionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFormSubmissionMutation(baseOptions?: Apollo.MutationHookOptions<CreateFormSubmissionMutation, CreateFormSubmissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFormSubmissionMutation, CreateFormSubmissionMutationVariables>(CreateFormSubmissionDocument, options);
      }
export type CreateFormSubmissionMutationHookResult = ReturnType<typeof useCreateFormSubmissionMutation>;
export type CreateFormSubmissionMutationResult = Apollo.MutationResult<CreateFormSubmissionMutation>;
export type CreateFormSubmissionMutationOptions = Apollo.BaseMutationOptions<CreateFormSubmissionMutation, CreateFormSubmissionMutationVariables>;
export const ArchiveFormSubmissionDocument = gql`
    mutation ArchiveFormSubmission($submissionID: ID!) {
  archiveFormSubmission(input: {id: $submissionID}) {
    id
  }
}
    `;
export type ArchiveFormSubmissionMutationFn = Apollo.MutationFunction<ArchiveFormSubmissionMutation, ArchiveFormSubmissionMutationVariables>;

/**
 * __useArchiveFormSubmissionMutation__
 *
 * To run a mutation, you first call `useArchiveFormSubmissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveFormSubmissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveFormSubmissionMutation, { data, loading, error }] = useArchiveFormSubmissionMutation({
 *   variables: {
 *      submissionID: // value for 'submissionID'
 *   },
 * });
 */
export function useArchiveFormSubmissionMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveFormSubmissionMutation, ArchiveFormSubmissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveFormSubmissionMutation, ArchiveFormSubmissionMutationVariables>(ArchiveFormSubmissionDocument, options);
      }
export type ArchiveFormSubmissionMutationHookResult = ReturnType<typeof useArchiveFormSubmissionMutation>;
export type ArchiveFormSubmissionMutationResult = Apollo.MutationResult<ArchiveFormSubmissionMutation>;
export type ArchiveFormSubmissionMutationOptions = Apollo.BaseMutationOptions<ArchiveFormSubmissionMutation, ArchiveFormSubmissionMutationVariables>;
export const UpdateFormSubmissionNameDocument = gql`
    mutation UpdateFormSubmissionName($input: UpdateFormSubmissionNameInput!) {
  updateFormSubmissionName(input: $input) {
    id
    name
    updatedAt
  }
}
    `;
export type UpdateFormSubmissionNameMutationFn = Apollo.MutationFunction<UpdateFormSubmissionNameMutation, UpdateFormSubmissionNameMutationVariables>;

/**
 * __useUpdateFormSubmissionNameMutation__
 *
 * To run a mutation, you first call `useUpdateFormSubmissionNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFormSubmissionNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFormSubmissionNameMutation, { data, loading, error }] = useUpdateFormSubmissionNameMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFormSubmissionNameMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFormSubmissionNameMutation, UpdateFormSubmissionNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFormSubmissionNameMutation, UpdateFormSubmissionNameMutationVariables>(UpdateFormSubmissionNameDocument, options);
      }
export type UpdateFormSubmissionNameMutationHookResult = ReturnType<typeof useUpdateFormSubmissionNameMutation>;
export type UpdateFormSubmissionNameMutationResult = Apollo.MutationResult<UpdateFormSubmissionNameMutation>;
export type UpdateFormSubmissionNameMutationOptions = Apollo.BaseMutationOptions<UpdateFormSubmissionNameMutation, UpdateFormSubmissionNameMutationVariables>;
export const StartFormSubmissionExtractionDocument = gql`
    mutation StartFormSubmissionExtraction($input: StartFormSubmissionExtractionInput!) {
  startFormSubmissionExtraction(input: $input) {
    id
    status
  }
}
    `;
export type StartFormSubmissionExtractionMutationFn = Apollo.MutationFunction<StartFormSubmissionExtractionMutation, StartFormSubmissionExtractionMutationVariables>;

/**
 * __useStartFormSubmissionExtractionMutation__
 *
 * To run a mutation, you first call `useStartFormSubmissionExtractionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartFormSubmissionExtractionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startFormSubmissionExtractionMutation, { data, loading, error }] = useStartFormSubmissionExtractionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStartFormSubmissionExtractionMutation(baseOptions?: Apollo.MutationHookOptions<StartFormSubmissionExtractionMutation, StartFormSubmissionExtractionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartFormSubmissionExtractionMutation, StartFormSubmissionExtractionMutationVariables>(StartFormSubmissionExtractionDocument, options);
      }
export type StartFormSubmissionExtractionMutationHookResult = ReturnType<typeof useStartFormSubmissionExtractionMutation>;
export type StartFormSubmissionExtractionMutationResult = Apollo.MutationResult<StartFormSubmissionExtractionMutation>;
export type StartFormSubmissionExtractionMutationOptions = Apollo.BaseMutationOptions<StartFormSubmissionExtractionMutation, StartFormSubmissionExtractionMutationVariables>;
export const SetFormSubmissionAnswerDocument = gql`
    mutation SetFormSubmissionAnswer($input: SetFormSubmissionAnswerInput!) {
  setFormSubmissionAnswer(input: $input) {
    answer {
      ...FormsAnswerReview_Answer
    }
    conflict {
      expectedLockVersion
      actualLockVersion
      currentAnswer {
        ...FormsAnswerReview_Answer
      }
    }
  }
}
    ${FormsAnswerReview_AnswerFragmentDoc}`;
export type SetFormSubmissionAnswerMutationFn = Apollo.MutationFunction<SetFormSubmissionAnswerMutation, SetFormSubmissionAnswerMutationVariables>;

/**
 * __useSetFormSubmissionAnswerMutation__
 *
 * To run a mutation, you first call `useSetFormSubmissionAnswerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetFormSubmissionAnswerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setFormSubmissionAnswerMutation, { data, loading, error }] = useSetFormSubmissionAnswerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetFormSubmissionAnswerMutation(baseOptions?: Apollo.MutationHookOptions<SetFormSubmissionAnswerMutation, SetFormSubmissionAnswerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetFormSubmissionAnswerMutation, SetFormSubmissionAnswerMutationVariables>(SetFormSubmissionAnswerDocument, options);
      }
export type SetFormSubmissionAnswerMutationHookResult = ReturnType<typeof useSetFormSubmissionAnswerMutation>;
export type SetFormSubmissionAnswerMutationResult = Apollo.MutationResult<SetFormSubmissionAnswerMutation>;
export type SetFormSubmissionAnswerMutationOptions = Apollo.BaseMutationOptions<SetFormSubmissionAnswerMutation, SetFormSubmissionAnswerMutationVariables>;
export const ClearFormSubmissionAnswerDocument = gql`
    mutation ClearFormSubmissionAnswer($input: ClearFormSubmissionAnswerInput!) {
  clearFormSubmissionAnswer(input: $input) {
    answer {
      ...FormsAnswerReview_Answer
    }
    conflict {
      expectedLockVersion
      actualLockVersion
      currentAnswer {
        ...FormsAnswerReview_Answer
      }
    }
  }
}
    ${FormsAnswerReview_AnswerFragmentDoc}`;
export type ClearFormSubmissionAnswerMutationFn = Apollo.MutationFunction<ClearFormSubmissionAnswerMutation, ClearFormSubmissionAnswerMutationVariables>;

/**
 * __useClearFormSubmissionAnswerMutation__
 *
 * To run a mutation, you first call `useClearFormSubmissionAnswerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearFormSubmissionAnswerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearFormSubmissionAnswerMutation, { data, loading, error }] = useClearFormSubmissionAnswerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useClearFormSubmissionAnswerMutation(baseOptions?: Apollo.MutationHookOptions<ClearFormSubmissionAnswerMutation, ClearFormSubmissionAnswerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClearFormSubmissionAnswerMutation, ClearFormSubmissionAnswerMutationVariables>(ClearFormSubmissionAnswerDocument, options);
      }
export type ClearFormSubmissionAnswerMutationHookResult = ReturnType<typeof useClearFormSubmissionAnswerMutation>;
export type ClearFormSubmissionAnswerMutationResult = Apollo.MutationResult<ClearFormSubmissionAnswerMutation>;
export type ClearFormSubmissionAnswerMutationOptions = Apollo.BaseMutationOptions<ClearFormSubmissionAnswerMutation, ClearFormSubmissionAnswerMutationVariables>;
export const EnqueueFormSubmissionWordExportDocument = gql`
    mutation EnqueueFormSubmissionWordExport($input: ExportFormSubmissionWordInput!) {
  enqueueFormSubmissionWordExport(input: $input) {
    id
    status
  }
}
    `;
export type EnqueueFormSubmissionWordExportMutationFn = Apollo.MutationFunction<EnqueueFormSubmissionWordExportMutation, EnqueueFormSubmissionWordExportMutationVariables>;

/**
 * __useEnqueueFormSubmissionWordExportMutation__
 *
 * To run a mutation, you first call `useEnqueueFormSubmissionWordExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnqueueFormSubmissionWordExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enqueueFormSubmissionWordExportMutation, { data, loading, error }] = useEnqueueFormSubmissionWordExportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEnqueueFormSubmissionWordExportMutation(baseOptions?: Apollo.MutationHookOptions<EnqueueFormSubmissionWordExportMutation, EnqueueFormSubmissionWordExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EnqueueFormSubmissionWordExportMutation, EnqueueFormSubmissionWordExportMutationVariables>(EnqueueFormSubmissionWordExportDocument, options);
      }
export type EnqueueFormSubmissionWordExportMutationHookResult = ReturnType<typeof useEnqueueFormSubmissionWordExportMutation>;
export type EnqueueFormSubmissionWordExportMutationResult = Apollo.MutationResult<EnqueueFormSubmissionWordExportMutation>;
export type EnqueueFormSubmissionWordExportMutationOptions = Apollo.BaseMutationOptions<EnqueueFormSubmissionWordExportMutation, EnqueueFormSubmissionWordExportMutationVariables>;
export const SetFormSubmissionAnswerReferencesDocument = gql`
    mutation SetFormSubmissionAnswerReferences($input: SetFormSubmissionAnswerReferencesInput!) {
  setFormSubmissionAnswerReferences(input: $input) {
    answer {
      ...FormsAnswerReview_Answer
    }
    conflict {
      expectedLockVersion
      actualLockVersion
      currentAnswer {
        ...FormsAnswerReview_Answer
      }
    }
  }
}
    ${FormsAnswerReview_AnswerFragmentDoc}`;
export type SetFormSubmissionAnswerReferencesMutationFn = Apollo.MutationFunction<SetFormSubmissionAnswerReferencesMutation, SetFormSubmissionAnswerReferencesMutationVariables>;

/**
 * __useSetFormSubmissionAnswerReferencesMutation__
 *
 * To run a mutation, you first call `useSetFormSubmissionAnswerReferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetFormSubmissionAnswerReferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setFormSubmissionAnswerReferencesMutation, { data, loading, error }] = useSetFormSubmissionAnswerReferencesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetFormSubmissionAnswerReferencesMutation(baseOptions?: Apollo.MutationHookOptions<SetFormSubmissionAnswerReferencesMutation, SetFormSubmissionAnswerReferencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetFormSubmissionAnswerReferencesMutation, SetFormSubmissionAnswerReferencesMutationVariables>(SetFormSubmissionAnswerReferencesDocument, options);
      }
export type SetFormSubmissionAnswerReferencesMutationHookResult = ReturnType<typeof useSetFormSubmissionAnswerReferencesMutation>;
export type SetFormSubmissionAnswerReferencesMutationResult = Apollo.MutationResult<SetFormSubmissionAnswerReferencesMutation>;
export type SetFormSubmissionAnswerReferencesMutationOptions = Apollo.BaseMutationOptions<SetFormSubmissionAnswerReferencesMutation, SetFormSubmissionAnswerReferencesMutationVariables>;